@if (workspaces$ | async; as workspaces) {
  <div id="tabContent" class="tabContent">
    <div class="">
      <pp-grid [ppOptions]="{ bodyPadding: false }">
        <ng-container title>
          {{ 'custom_fields' | ppTranslate }}
        </ng-container>

        <ng-container titleBar-right>
          <pp-button
            ppId="addNewCFBtn"
            data-test="addNewCFBtn"
            data-m-target="Add new custom field button"
            ppStyle="primary"
            ppSize="small"
            (ppAction)="addCustomField()"
          >
            {{ 'add_new_cf' | ppTranslate }}
          </pp-button>
        </ng-container>

        <ng-container body>
          @if (workspaces && workspaces[workspaceId]) {
            <div>
              @if (!workspacesLoaded) {
                <div class="settingsSection__no-content">
                  <pp-spinner />
                </div>
              } @else {
                <pp-site-settings-custom-fields-table [ppWorkspaceId]="workspaceId" />
              }

              @if (
                (!workspaces[workspaceId].customFields ||
                  workspaces[workspaceId].customFields.length === 0) &&
                workspacesLoaded
              ) {
                <div class="settingsSection__no-content">
                  {{ 'no_cfs_found' | ppTranslate }}
                </div>
              }
            </div>
          }
        </ng-container>
      </pp-grid>
    </div>
  </div>
}
